/**
 * Moon Constants
 * Shared constants for Moon rendering
 */

export const DEFAULT_SPHERE_SEGMENTS = 128
export const MOON_AXIAL_TILT = 1.54 // degrees (Moon's axial tilt relative to ecliptic)
